<template>
  <div v-if="authenticated && !isTesting">
    <b-navbar toggleable="lg" style="z-index: 21">
      <b-navbar-toggle target="navbar-example-16"></b-navbar-toggle>

      <b-collapse is-nav id="navbar-example-16">
        <b-navbar-nav>
          <b-nav-item>
            <router-link tag="li" :to="{name: 'main'}">
              Acasă
            </router-link>
          </b-nav-item>

          <b-nav-item>
            <router-link tag="li" :to="{name: 'classes'}">
              Teste
            </router-link>
          </b-nav-item>

          <b-nav-item>
            <router-link tag="li" :to="{name: 'profile'}">
              Rezultate
            </router-link>
          </b-nav-item>

          <b-nav-item v-if="user.admin">
            <router-link tag="li" :to="{name: 'admin'}">
              Admin
            </router-link>
          </b-nav-item>
            </b-navbar-nav>
          </b-collapse>

          <b-navbar-brand href="javascript:void(0)">
            <router-link tag="li" :to="{name: 'main'}">
              <img src="../img/albinuta.png" width="40px" height="40px">
            </router-link>
          </b-navbar-brand>

          <button class="buton btn" @click="$refs.alertLogout.open()">
            Log Out, {{user.name}}
          </button>
    </b-navbar>


    <sweet-modal ref="alertLogout" icon="warning">
      <div>Ești sigur că vrei să ieși din cont?</div>

      <div>
        <button type="button" class="buton btn" style="margin-right: 2vh;" @click="logout()">Da</button>
        <button type="button" class="buton btn" @click="$refs.alertLogout.close()">Anulează</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'
export default {
  computed: {
    ...mapGetters({
     user: 'auth/user',
     authenticated: 'auth/authenticated',
     isTesting: 'globals/isTesting'
   })
  },

  components: {
    SweetModal
  },

  methods: {
    ...mapActions({
      logoutAction: 'auth/logout'
    }),

    logout() {
      this.logoutAction().finally(() => {
        this.$router.replace({ name: 'main' })
      })
    }
  }
}

</script>

<style scoped>
li {
  display: inline;
  padding: 0.5vh;
}

.push {
  position: absolute;
  right: 2vh;
}
</style>
